import {
  CheckBadgeIcon,
  ClockIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import RPCardOne from "../../Componenten/Cards/RPCardOne";

const vragenlijsten = [
  {
    title: "Gezondheidstijdlijn (pre-intake)",
    subtitle: "Jouw context, doelen en hulpvraag — de basis voor het intakegesprek.",
    icon: ClockIcon,
    iconTileClass:
      "bg-wa-panel text-wa-accent ring-1 ring-inset ring-wa-border/70",
  },
  {
    title: "Klachtenregistratie",
    subtitle: "Overzicht van klachten en lichaamsgebieden die we meenemen.",
    icon: CheckBadgeIcon,
    iconTileClass:
      "bg-wa-panel text-violet-500 dark:text-violet-300 ring-1 ring-inset ring-wa-border/70",
  },
  {
    title: "Voedingsdagboek",
    subtitle: "Inzicht in eetpatroon en voeding rondom jouw traject.",
    icon: UsersIcon,
    iconTileClass:
      "bg-wa-panel text-sky-600 dark:text-sky-300 ring-1 ring-inset ring-wa-border/70",
  },
];

function BeforePreIntake() {
  return (
    <div className="mx-auto flex w-full max-w-5xl flex-col px-2 py-6 sm:px-4 lg:py-10">
      <div className="relative overflow-hidden rounded-2xl border border-wa-border bg-wa-panel2/40 shadow-[0_22px_55px_-28px_rgba(0,0,0,0.45)] ring-1 ring-black/5 dark:bg-wa-panel/35 dark:ring-white/5">
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.12] dark:opacity-[0.18]"
          aria-hidden="true"
          style={{
            background:
              "radial-gradient(900px 320px at 12% -10%, rgb(var(--wa-accent) / 0.35), transparent 55%), radial-gradient(700px 280px at 100% 0%, rgb(99 102 241 / 0.2), transparent 50%)",
          }}
        />
        <div className="relative px-5 py-8 sm:px-10 sm:py-10">
          <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-wa-muted">
            Intake
          </p>
          <h2 className="mt-2 text-center text-2xl font-bold tracking-tight text-wa-text sm:text-3xl">
            Bedankt voor het boeken van je gesprek
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-wa-muted sm:text-[15px]">
            Om jou zo persoonlijk mogelijk te begeleiden, vragen we je om{" "}
            <span className="font-semibold text-wa-text">drie vragenlijsten</span> in te
            vullen vóór het intakegesprek. Zo kennen we jouw situatie beter en kan het
            gesprek gerichter plaatsvinden.
          </p>

          <ul
            role="list"
            className="mx-auto mt-8 grid max-w-4xl grid-cols-1 gap-4 sm:mt-10 sm:grid-cols-3 sm:gap-5"
          >
            {vragenlijsten.map((type) => (
              <RPCardOne key={type.title} item={type} />
            ))}
          </ul>

          <p className="mx-auto mt-8 max-w-2xl text-center text-sm leading-relaxed text-wa-muted sm:mt-10 sm:text-[15px]">
            Tijdens het intakegesprek lopen we deze vragenlijsten samen door, bespreken we
            je hulpvraag en je doelen. Elk advies wordt afgestemd op jouw gezondheidssituatie.
          </p>
        </div>
      </div>
    </div>
  );
}

export default BeforePreIntake;
